module.exports = __webpack_public_path__ + "static/img/bg-ar.bc11cc1b.webp";